import { render, staticRenderFns } from "./PresentationViewer.vue?vue&type=template&id=fc6d8888&"
import script from "./PresentationViewer.vue?vue&type=script&lang=js&"
export * from "./PresentationViewer.vue?vue&type=script&lang=js&"
import style0 from "./PresentationViewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports